/**
 * Util method to conver arrays of data to a dropdown or autocomplete format
 *
 * @param {array} data
 * @param {object} options
 */
export const createSuggestions = (data = [], options = {}) => {
  const {
    labelKey = "label",
    valueKey = "value",
    labelDataKey = null,
    valueDataKey = null,
    shouldBeUnique = false,
    includeItemObject = false
  } = options;
  let suggestions = [];
  data === null || data === void 0 ? void 0 : data.forEach(item => {
    const suggestion = {
      [labelKey]: labelDataKey ? item[labelDataKey] : item,
      [valueKey]: valueDataKey ? item[valueDataKey] : labelDataKey ? item[labelDataKey] : item
    };
    if (includeItemObject) {
      suggestions.push({
        ...item,
        ...suggestion
      });
    } else {
      suggestions.push(suggestion);
    }
  });
  if (shouldBeUnique) {
    const unique = [];
    const seen = {};
    suggestions.map(item => {
      if (!seen[item[labelKey]]) {
        seen[item[labelKey]] = item;
        unique.push(item);
      }
    });
    suggestions = unique;
  }
  return suggestions;
};
export const convertSuggestionsToLabelArray = suggestions => {
  const data = [];
  suggestions.map(suggestion => {
    data.push(suggestion.label);
  });
  return data;
};
export const findSuggestionFromList = (suggestions, options) => {
  const {
    value
  } = options;
  const selectedItem = suggestions.filter(item => {
    return item.value === value;
  });
  return selectedItem[0];
};
export const getCountryCodesFromGroupTags = (groupTags, selectedTags, selectedTenants) => {
  const countryCodes = [];
  const suggestions = [];
  for (const groupTag of groupTags) {
    const {
      tagName,
      tenantGroups
    } = groupTag;
    let allowCountryCodeForTagname = true;
    if ((selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.length) > 0) {
      allowCountryCodeForTagname = selectedTags.includes(tagName);
    }
    if (allowCountryCodeForTagname) {
      tenantGroups.forEach(tg => {
        const {
          tenantName
        } = tg;
        let allowCountryCodeForTenant = true;
        if ((selectedTenants === null || selectedTenants === void 0 ? void 0 : selectedTenants.length) > 0) {
          allowCountryCodeForTenant = selectedTenants.includes(tenantName);
        }
        if (allowCountryCodeForTenant) {
          tg.groups.forEach(group => {
            if (!countryCodes.includes(group.country)) {
              countryCodes.push(group.country);
              suggestions.push({
                label: group.country,
                value: group.country
              });
            }
          });
        }
      });
    }
  }
  return suggestions;
};
export const getGroupSuggestions = (groupTags, tags, countrySelected, tenants) => {
  const groupNames = [];
  const suggestions = [];
  const testForTenant = (tenants === null || tenants === void 0 ? void 0 : tenants.length) > 0;
  const filteredGroupTags = groupTags.filter(groupTag => tags.includes(groupTag.tagName));
  for (const groupTag of filteredGroupTags) {
    const {
      tenantGroups
    } = groupTag;
    tenantGroups.forEach(tg => {
      const {
        tenantName
      } = tg;
      let allowForTenant = !testForTenant;
      if (testForTenant) {
        allowForTenant = tenants.includes(tenantName);
      }
      if (allowForTenant) {
        tg.groups.forEach(group => {
          let allowGroupAddition = true;
          if (countrySelected) {
            allowGroupAddition = group.country === countrySelected;
          }
          if (allowGroupAddition && !groupNames.includes(group.groupName)) {
            groupNames.push(group.groupName);
            suggestions.push({
              label: group.groupName,
              value: group.groupName
            });
          }
        });
      }
    });
  }
  return suggestions;
};
export const getTagsAndSuggestionsFromGroupNames = (gTags, groups) => {
  const groupTags = gTags || [];
  const newTags = [];
  const suggestions = [];
  for (const groupName of groups) {
    for (const groupTag of groupTags) {
      const {
        tagName,
        tenantGroups
      } = groupTag;
      const result = tenantGroups.some(tg => tg.groups.some(group => groupName === group.groupName));
      if (result && !newTags.includes(tagName)) {
        newTags.push(tagName);
        suggestions.push({
          label: tagName,
          value: tagName
        });
      }
    }
  }
  return {
    tags: newTags,
    suggestions
  };
};
export const getTagSuggestionsFromTenants = (groupTags, tenants, countrySelected) => {
  const newTags = [];
  const suggestions = [];
  const addTagSuggestions = tagName => {
    if (!newTags.includes(tagName)) {
      newTags.push(tagName);
      suggestions.push({
        label: tagName,
        value: tagName
      });
    }
  };
  const handleCountryCode = (group, tagName) => {
    if (countrySelected) {
      if (group.country === countrySelected) {
        addTagSuggestions(tagName);
      }
    }
  };
  const handleTenantGroups = (tagName, tenantName, countrySelected, tenantGroups) => {
    for (const tg of tenantGroups) {
      if (tg.tenantName === tenantName) {
        for (const group of tg.groups) {
          handleCountryCode(group, tagName);
        }
      }
    }
  };
  for (const tenantName of tenants) {
    for (const groupTag of groupTags) {
      const {
        tagName,
        tenantGroups
      } = groupTag;
      let result;
      if (countrySelected) {
        handleTenantGroups(tagName, tenantName, countrySelected, tenantGroups);
      } else {
        result = tenantGroups.some(tg => tenantName === tg.tenantName);
        if (result) {
          addTagSuggestions(tagName);
        }
      }
    }
  }
  return suggestions;
};
export const evalTagsFromGroupNames = (groupTags, groups) => {
  const {
    tags
  } = getTagsAndSuggestionsFromGroupNames(groupTags, groups);
  return tags;
};
export const getTenantSelectionFromGroupsAndTags = (gTags, groups) => {
  const groupTags = gTags || [];
  const tenantNames = [];
  const groupNames = [];
  const evalTenantGroup = (tg, groupName) => {
    for (const group of tg.groups) {
      if (!tenantNames.includes(tg.tenantName) && group.groupName === groupName && !groupNames.includes(group.groupName)) {
        groupNames.push(group.groupName);
        tenantNames.push(tg.tenantName);
      }
    }
  };
  for (const groupName of groups) {
    for (const groupTag of groupTags) {
      const {
        tenantGroups
      } = groupTag;
      for (const tg of tenantGroups) {
        evalTenantGroup(tg, groupName);
      }
    }
  }
  return tenantNames;
};